export default "__VITE_ASSET__aaf0ecb0__"